module.exports = __webpack_public_path__ + "static/media/Government_of_India_logo.bb7827c7.png";